import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const comsP1Template = (
  node: HTMLElement,
) => unsafeHTML(
  `<one-paper background="legal-1" padding="sm" text-color="make-links-blau">
    ${node.innerHTML}
  </one-paper>`,
);

export const comsP2Template = (
  node: HTMLElement,
) => unsafeHTML(
  `<one-paper background="legal-2" padding="sm" text-color="make-links-blau">
    ${node.innerHTML}
  </one-paper>`,
);

export const comsP3Template = (
  node: HTMLElement,
) => unsafeHTML(
  `<one-paper background="legal-3" padding="sm" text-color="make-links-blau">
    ${node.innerHTML}
  </one-paper>`,
);
